// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDtlVGLtHabxd_BW3JcvzhP0RVGhT5VC7M',
  authDomain: 'church-80789.firebaseapp.com',
  projectId: 'church-80789',
  storageBucket: 'church-80789.firebasestorage.app',
  messagingSenderId: '480040705151',
  appId: '1:480040705151:web:a939ec93bf65bd2c52734a',
  measurementId: 'G-PDN3GEXXCT',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
// const analytics = getAnalytics(app);
const provider = new GoogleAuthProvider()

export { auth, provider, signInWithPopup }
